module.exports = __webpack_public_path__ + "img/account-circle.e302724.svg";